import axios from "axios";
import { session, UNAUTHORIZED_MESSAGES, TOKEN_EXPIRED_MESSAGE } from "./session";

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error?.response?.status <= 400) {
      const errorMessage = error?.response?.data?.error

      if (UNAUTHORIZED_MESSAGES.includes(errorMessage))
        return session.deleteSession();

      if (TOKEN_EXPIRED_MESSAGE.includes(errorMessage))
        return session.retryWithRefreshToken((accessToken) => {
          const requestConfig = error.config;
          requestConfig.headers["Authorization"] = `Bearer ${accessToken}`;

          return axios(requestConfig);
        });
    }

    throw error;
  }
);
